import React, { useEffect } from 'react';
import { ArrowLeft, Home } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';
import { useLanguage } from '../contexts/LanguageContext';
import { withLang } from '../components/LanguageRouter';
import Header from '../components/Header';
import Footer from '../components/Footer';

const TermsOfService = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { currentLanguage } = useLanguage();

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <div className="pt-20 pb-16 bg-gray-50">
        <div className="container mx-auto px-6">
          {/* Navigation Bar */}
          <div className="mb-6 flex items-center justify-between">
            <button
              onClick={() => navigate(-1)}
              className="flex items-center text-blue-600 hover:text-blue-800 transition-colors duration-200"
            >
              <ArrowLeft className="w-5 h-5 mr-2" />
              {t('legal.goBack')}
            </button>
            <Link
              to={withLang(currentLanguage)}
              className="flex items-center text-gray-600 hover:text-blue-600 transition-colors duration-200"
            >
              <Home className="w-5 h-5 mr-2" />
              {t('footer.home')}
            </Link>
          </div>

          <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-8">
            <h1 className="text-4xl font-bold text-blue-900 mb-8">{t('legal.terms.title')}</h1>
            <p className="text-gray-600 mb-8">{t('legal.lastUpdated')}</p>

            <div className="space-y-8">
              <section>
                <h2 className="text-2xl font-bold text-blue-900 mb-4">{t('legal.terms.section1.title')}</h2>
                <p className="text-gray-700 leading-relaxed">
                  {t('legal.terms.section1.content')}
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-blue-900 mb-4">{t('legal.terms.section2.title')}</h2>
                <div className="bg-blue-50 p-4 rounded-lg">
                  <p className="text-gray-700 mb-2">{t('legal.terms.section2.company')}</p>
                  <p className="text-gray-700 mb-2">{t('legal.terms.section2.address')}</p>
                  <p className="text-gray-700 mb-2">{t('legal.terms.section2.phone')}</p>
                  <p className="text-gray-700 mb-2">{t('legal.terms.section2.email')}</p>
                  <p className="text-gray-700 mb-4">{t('legal.terms.section2.founded')}</p>
                  <p className="text-gray-700">{t('legal.terms.section2.services')}</p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-blue-900 mb-4">{t('legal.terms.section3.title')}</h2>
                <p className="text-gray-700 leading-relaxed">
                  {t('legal.terms.section3.content')}
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-blue-900 mb-4">{t('legal.terms.section4.title')}</h2>
                <p className="text-gray-700 leading-relaxed">
                  {t('legal.terms.section4.content')}
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-blue-900 mb-4">{t('legal.terms.section5.title')}</h2>
                <p className="text-gray-700 leading-relaxed">
                  {t('legal.terms.section5.content')}
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-blue-900 mb-4">{t('legal.terms.section6.title')}</h2>
                <p className="text-gray-700 leading-relaxed">
                  {t('legal.terms.section6.content')}
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-blue-900 mb-4">8. Governing Law</h2>
                <p className="text-gray-700 leading-relaxed">
                  These terms and conditions are governed by and construed in accordance with the laws of the People's Republic of China, and you irrevocably submit to the exclusive jurisdiction of the courts in Xiamen, Fujian Province.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-blue-900 mb-4">9. Contact Information</h2>
                <p className="text-gray-700 leading-relaxed">
                  If you have any questions about these Terms of Service, please contact us at:
                </p>
                <div className="bg-blue-50 p-4 rounded-lg mt-4">
                  <p className="text-gray-700"><strong>Email:</strong> office@towertech-xm.com</p>
                  <p className="text-gray-700"><strong>Phone:</strong> +86 15381939338</p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsOfService;
